export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 980,
  SMALL: 600,
} as const;
